var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModifypassengerTravel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18667_18888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 20C25.21 20 27 18.21 27 16C27 13.79 25.21 12 23 12C20.79 12 19 13.79 19 16C19 18.21 20.79 20 23 20ZM23 14C24.1 14 25 14.9 25 16C25 17.1 24.1 18 23 18C21.9 18 21 17.1 21 16C21 14.9 21.9 14 23 14ZM23 22C20.33 22 15 23.34 15 26V28H31V26C31 23.34 25.67 22 23 22ZM17 26C17.22 25.28 20.31 24 23 24C25.7 24 28.8 25.29 29 26H17ZM14 23V20H17V18H14V15H12V18H9V20H12V23H14Z",
    fill: "#00A9E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18667_18888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModifypassengerTravel);
export default __webpack_public_path__ + "static/media/modifypassenger-travel.026d501238950847ded47e163adb6f39.svg";
export { ForwardRef as ReactComponent };